import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import moment from "moment";
import { DatepickerDateCustomClasses } from "ngx-bootstrap/datepicker";

@Component({
    selector: "nbc-multiselect-calendar",
    templateUrl: "./nbc-multiselect-calendar.component.html",
    styleUrls: ["./nbc-multiselect-calendar.component.css"],
    standalone: false
})
export class NbcMultiselectCalendar implements OnInit {
    constructor() {
        this.dateSelected = [];
    }

    @Input() dateFormat: any = "MMM-DD";
    @Input() selectedDates: any = [];
    @Output() selectedDatesChange: EventEmitter<any> = new EventEmitter();

    dateSelected: DatepickerDateCustomClasses[];
    selectedClass: any = [];
    isVisible: any = true;
    bsInlineValue?: Date;

    getDateItem(date: Date): string {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }

    onValueChange(event: any) {
        this.selectedDates = [];

        if (this.bsInlineValue === event) {
            return;
        }
        this.isVisible = false;

        if (event?.length === undefined) {
            const date = this.getDateItem(event);

            const index = this.dateSelected.findIndex((item: any) => {
                const testDate = this.getDateItem(item);
                return testDate === date;
            });

            if (index < 0) {
                this.dateSelected.push(event);
            } else {
                this.dateSelected.splice(index, 1);
            }
        }

        if (this.dateSelected.length > 0) {
            this.selectedClass = this.dateSelected.map((date: any) => {
                this.selectedDates.push({
                    date: moment(date).format(),
                    displayDate: moment(date).format(this.dateFormat),
                });
                return {
                    date: date,
                    classes: ["custom-selected-date"],
                };
            });
            this.selectedDatesChange.emit(this.selectedDates);
        }
        if (this.dateSelected.length == 0) {
            this.selectedClass = null;
            this.selectedDatesChange.emit(this.selectedDates);
        }

        setTimeout(() => {
            this.bsInlineValue = event;
            this.isVisible = true;
        }, 50);
    }

    ngOnInit() {}
}
